let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lAVaN")).then(() => parcelRequire('5UaLs'));